import { render, staticRenderFns } from "./receiveCard.vue?vue&type=template&id=6aa8c89f&scoped=true&"
import script from "./receiveCard.vue?vue&type=script&lang=js&"
export * from "./receiveCard.vue?vue&type=script&lang=js&"
import style0 from "./receiveCard.vue?vue&type=style&index=0&id=6aa8c89f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8c89f",
  null
  
)

export default component.exports